import { Typography, AppBar, Toolbar } from '@mui/material';
import React from 'react';
// import { Textfit } from 'react-textfit';

import '../../assets/styles/Header.scss';


interface NavBarProps {
  environmentWarning?: string;
  tldr?: string;
}


export const Footer: React.FC<NavBarProps> = ({ tldr }) => {
    // export function Footer() {
      return (
          <AppBar id="div_Footer" position="fixed" color="primary" sx={{ top: 'auto', bottom: 0 }}>
            <Toolbar>
            {/* <Textfit mode="multi" min={10} max={24}> */}
                {tldr}
              {/* </Textfit>               */}
            </Toolbar>
          </AppBar>
      );
    }